import addressMap from '../Address.json';
const cleanse = (v) => (v || '').trim().replace(/["'`]/g, '');
const supportedIds = Object.keys(addressMap || {}).map(k => Number(k)).filter(n => Number.isFinite(n));

export const getChainId = () => {
  try {
    const raw = typeof window !== 'undefined' && window.ethereum ? window.ethereum.chainId : '';
    if (raw && typeof raw === 'string') {
      const hex = cleanse(raw);
      const parsed = hex.startsWith('0x') ? parseInt(hex, 16) : Number(hex);
      if (Number.isFinite(parsed) && supportedIds.includes(parsed)) return parsed;
    }
    const envId =
      (typeof process !== 'undefined' && process?.env?.REACT_APP_CHAIN_ID) ||
      (typeof process !== 'undefined' && process?.env?.VITE_CHAIN_ID) ||
      (typeof process !== 'undefined' && process?.env?.NEXT_PUBLIC_CHAIN_ID);
    if (envId) {
      const n = Number(cleanse(envId));
      if (Number.isFinite(n) && supportedIds.includes(n)) return n;
    }
  } catch (_) { }
  return supportedIds.length ? supportedIds[0] : 421614;
};

export const getRpcUrl = () => {
  try {
    const envUrl =
      (typeof process !== 'undefined' && process?.env?.REACT_APP_RPC_URL) ||
      (typeof process !== 'undefined' && process?.env?.VITE_RPC_URL) ||
      (typeof process !== 'undefined' && process?.env?.NEXT_PUBLIC_RPC_URL);
    if (envUrl && typeof envUrl === 'string' && envUrl.trim()) return envUrl.trim();
  } catch (_) { }
  return '';
};

export const getAddressesById = (chainId) => {
  const id = Number(chainId);
  const finalId = Number.isFinite(id) ? id : getChainId();
  const byFile = addressMap?.[String(finalId)] || {};
  return {
    chainId: finalId,
    USDC: byFile.USDC || '',
    AroundPoolFactory: byFile.AroundPoolFactory || '',
    AroundMarket: byFile.AroundMarket || '',
    AroundUIHelper: byFile.AroundUIHelper || '',
    AroundRouter: byFile.AroundRouter || '',
  };
};

export const getAddresses = () => getAddressesById(getChainId());
